import React, { useEffect, useState } from 'react'
import { Alert, Button, Form, Input, Select, Skeleton, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import Flex from '../../../components/Flex';
import useScrapingUsage from '../../../hooks/useScrapingUsage';
import { PiPlugsLight } from "react-icons/pi";
import { IconContext } from "react-icons";
import useScrapingCredentials from "../../../hooks/useScrapingCredentials";
import useMe from "../../../hooks/useMe";
import { ClearScrapingButton } from './PjnNumberInput';


export function SrtCausaInput({ getFieldDecorator, isFieldTouched, getFieldError, expedient, editing }) {

    const srtInputError = isFieldTouched("causa_srt") && getFieldError("causa_srt");
    const { usage, loading: usageLoading } = useScrapingUsage('srt');
    const { credentials, loading: srtLoading } = useScrapingCredentials("srt");
    const emptyCredentials = !credentials || credentials.length === 0;
    const { user } = useMe()
    const noUsageLeft = !(usage && usage.used < usage.total)

    const alreadyVinculted = editing && expedient && expedient.causa_srt && expedient.causa_srt.length > 0;



    if (usageLoading || srtLoading) {
        return (
            <Form.Item>
                <Skeleton className="responsive-input" paragraph={{ rows: 1 }} active />
            </Form.Item>
        );
    }

    return (
        <Flex flexDirection="column">
            <Form.Item
                help={
                    srtInputError ? "Ingrese solo números sin prefijo ni sufijo" :
                        emptyCredentials ? "No posee credenciales SRT" :
                            noUsageLeft ? "Limite SRT de su plan alcanzado" :
                                `Vinculaciones SRT restantes: ${usage ? usage.left : "..."}`
                }
                labelCol={{ span: 24 }}
                key="causa_srt"
                label={
                    <Flex flexDirection="row" gap="1ch">
                        <Typography.Text>
                            Causa SRT{" "}
                            <Tooltip title="Solo numero de SRT">
                                <InfoCircleOutlined />
                            </Tooltip>
                        </Typography.Text>
                    </Flex>
                }
                validateStatus={srtInputError ? "error" : "success"}
            >
                {getFieldDecorator("causa_srt", {
                    initialValue: editing ? expedient.causa_srt || null : null
                })(
                    <SrtCausaInputWrapper disabled={emptyCredentials || (noUsageLeft && !alreadyVinculted)} />
                )}
            </Form.Item>

            {emptyCredentials ?
                <a href="/settings#integraciones" style={{ alignSelf: "end" }}>
                    <Button type="primary">Configurar SRT</Button>
                </a> :
                noUsageLeft ?
                    <a href="https://metajuridico.com/planes_actualizacion.html" style={{ alignSelf: "end" }}>
                        <Button type="primary">Ampliar Plan</Button>
                    </a> : null}
        </Flex>
    );
}

const SrtCausaInputWrapper = ({ value, onChange, disabled }) => {

    const clearSrt = () => {
        onChange && onChange("");
    };

    return (<Flex flexDirection="row" gap="1ch" alignItems="center" flexGrow={1}>
        <Flex flexDirection="column" gap="0.5ch" flexGrow={1}>
            <label style={{ fontSize: "10px" }}>Numero</label>
            <Input
                disabled={disabled}
                style={{ width: "100%" }}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder="123456/78"
                maxLength={9}
                pattern="\d{4,6}/\d{2}"
                className="responsive-input"
            />
        </Flex>
        <Flex flexDirection="column" gap="0.5ch" alignItems="center">
            <label style={{ fontSize: "10px" }}>&nbsp;</label>
            <ClearScrapingButton onClick={clearSrt} disabled={disabled} tooltipText="Eliminar causa SRT" />
        </Flex>
    </Flex>)
}